import React from 'react';
import {connect} from 'react-redux';
import PropTypes from "prop-types";
import IndicatorUtils from "../../utils/IndicatorUtils";
import axios from "axios";
import xml2js from 'xml2js';
import Spinner from "qwc2/components/widgets/Spinner";

class IndicatorLegend extends React.Component {
    static propTypes = {
        selectedIndicator: PropTypes.object
    }
    static defaultProps = {}

    constructor(props) {
        super(props);

        this.state = {
            data: {},
            isLoading: true,
            url: null
        };
    }

    getSld() {
        return IndicatorUtils.getSld(this.props.selectedIndicator);
    }

    getImage() {
        return IndicatorUtils.getLegendImage(this.props.selectedIndicator);
    }

    updateChart() {
        const image = this.getImage();
        if (image) {
            return;
        }

        const url = this.getSld();
        if (url) {
            const self = this;
            axios(url).then(response => {
                const xml = response.data.replace("\ufeff", "");
                xml2js.parseString(
                    xml, {
                        tagNameProcessors: [xml2js.processors.stripPrefix],
                        explicitArray: false
                    },
                    (error, result) => {
                        if (result === undefined) {
                            console.log("Parse error *** : " + response.data);
                            console.log(error);
                        } else {
                            self.setState({
                                data: result,
                                isLoading: false,
                                url: url
                            });
                        }
                    });

            }).catch(error => {
                console.log("Error *** : " + error);
            });
        }
    }

    componentDidMount() {
        this.updateChart();
    }

    componentDidUpdate() {
        const url = this.getSld();
        if (url !== this.state.url) {
            this.updateChart();
        }
    }

    render() {
        if (this.getImage()) {
            return this.renderImage();
        } else if (this.getSld()) {
            return this.renderSldTable();
        } else {
            return this.renderRangesTable();
        }
    }

    renderSldTable() {
        if (this.state.isLoading) {
            return (
                <Spinner/>
            );
        }

        const rules = [];
        if (this.state.data && this.state.data.StyledLayerDescriptor) {
            const sld = this.state.data && this.state.data.StyledLayerDescriptor;
            if (sld.NamedLayer && sld.NamedLayer.UserStyle && sld.NamedLayer.UserStyle.FeatureTypeStyle && sld.NamedLayer.UserStyle.FeatureTypeStyle.Rule) {
                let sldRules = sld.NamedLayer.UserStyle.FeatureTypeStyle.Rule;
                if (sldRules && !Array.isArray(sldRules)) {
                    sldRules = [sldRules];
                }
                if (sldRules && sldRules.length) {
                    sldRules.forEach((r => {
                        let name = r.Name;
                        if (r.Description && r.Description.Title) {
                            name = r.Description.Title;
                        }
                        if (!name) {
                            return;
                        }
                        const rule = {
                            name: name,
                            style: {
                                borderStyle: 'solid',
                                borderWidt: '1px',
                            }
                        };
                        if (r.PolygonSymbolizer && r.PolygonSymbolizer.Fill) {
                            let svg = r.PolygonSymbolizer.Fill.SvgParameter;
                            if (!Array.isArray(svg)) {
                                svg = [svg];
                            }
                            svg.forEach(s => {
                                if (s['$'] && s['$'].name == 'fill') {
                                    rule.style.backgroundColor = s['_'];
                                }
                            });
                        }
                        if (r.PolygonSymbolizer && r.PolygonSymbolizer.Stroke) {
                            let svg = r.PolygonSymbolizer.Stroke.SvgParameter;
                            if (!Array.isArray(svg)) {
                                svg = [svg];
                            }
                            svg.forEach(s => {
                                if (s['$'] && s['$'].name == 'stroke') {
                                    rule.style.borderColor = s['_'];
                                }
                                if (s['$'] && s['$'].name == 'stroke-width') {
                                    rule.style.borderWidth = s['_'] + 'px';
                                }
                            });
                        }

                        rules.push(rule);
                    }));
                    //{backgroundColor: range.color}
                }
            }
        }

        return (
            <table className="indicator-legend">
                <thead>
                <tr>
                    <th>Bereich</th>
                    <th>Farbe</th>
                </tr>
                </thead>
                <tbody>
                {rules.map(rule => {
                    return (
                        <tr key={"rule-" + rule.name}>
                            <td>{rule.name}</td>
                            <td><span className="color" style={rule.style}/></td>
                        </tr>
                    );
                })}
                </tbody>
            </table>
        );
    }

    renderRangesTable() {
        const ranges = IndicatorUtils.ranges(this.props.selectedIndicator);
        return (
            <table className="indicator-legend">
                <thead>
                <tr>
                    <th>Von</th>
                    <th>Bis</th>
                    <th>Farbe</th>
                </tr>
                </thead>
                <tbody>
                {ranges.map(range => {
                    return (
                        <tr key={"rangemin-" + range.min}>
                            <td>{Math.round(range.min, 1)}</td>
                            <td>{Math.round(range.max, 1)}</td>
                            <td><span className="color" style={{backgroundColor: range.color}}/></td>
                        </tr>
                    );
                })}
                </tbody>
            </table>
        );
    }

    renderImage() {
        const src = this.getImage();
        return (
            <div className="indicator-legend-image">
                <img src={src} alt="Indicator Legend" />
            </div>
        );
    }

}

const selector = (state) => ({
    selectedIndicator: state.indicators.selectedIndicator,
});

export default connect(selector, {})(IndicatorLegend);
